import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: "ionicon",
	viewBox: "0 0 512 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 32,
		d: "M256 112v288M400 256H112"
	})
});
export default SvgAdd;
